import { ref } from "vue";

export function useTableScrollX() {
  const tableScroll = ref<{ $el: HTMLElement } | null>(null);
  let scrollInterval: number;

  const getScrollElement = () => tableScroll.value?.$el || null;

  const scrollEnd = () => {
    const el = getScrollElement();
    if (el) el.scrollLeft += 5;
  };

  const scrollStart = () => {
    const el = getScrollElement();
    if (el) el.scrollLeft -= 5;
  };

  const scrollSmoothStart = (direction: number) => {
    const el = getScrollElement();
    if (!el) return;

    if (el.scrollLeft === el.scrollWidth || el.scrollLeft < 0) {
      scrollSmoothStop();
      return;
    }

    scrollInterval = setInterval(() => {
      if (el) el.scrollLeft += direction === 1 ? 2.5 : -2.5;
    }, 10);
  };

  const scrollSmoothStop = () => {
    clearInterval(scrollInterval);
  };

  return {
    tableScroll,
    scrollEnd,
    scrollStart,
    scrollSmoothStart,
    scrollSmoothStop,
  };
}